import {Component, Inject} from "@angular/core";
import {
    TrvGlobalMessagesService,
    TrvModalService,
    TrvPopoverPosition,
    TrvPopoverRef,
    TrvPopoverDirective
} from "@trv-hub/trv-ng-common";
import {LocalStorageService, SavedView} from "src/app/service/local-storage.service";
import {TrvNgMapService} from "@trafikverket/trv-ng-map";
import {SaveViewComponent} from "../save-view/save-view.component";
import { LanguageService } from "@app/service/language.service";

@Component({
    selector: "app-save-view-options",
    templateUrl: "./save-view-options.component.html",
    styleUrls: ["./save-view-options.component.scss"],
    imports: [ SaveViewComponent]
})
export class SaveViewOptionsComponent {
    public inputSavedView!: SavedView;

    public popoverPosition: TrvPopoverPosition[] = ["right", "bottom", "bottom-end", "bottom-start", "top-start", "top", "top-end"];
    public popoverComponent = SaveViewComponent;

    public editPopover = false;


    constructor(
        private trvPopoverRef: TrvPopoverRef,
        private localStorageService: LocalStorageService,
        @Inject(TrvNgMapService) private trvMapService: TrvNgMapService,
        @Inject(TrvModalService) private trvModalService: TrvModalService,
        @Inject(TrvGlobalMessagesService)
        private globalMessagesService: TrvGlobalMessagesService,
        public lang: LanguageService
    ) {
    }

    public gotoView() {
        this.trvMapService.trvMap?.setMapStateWithCoord(
            this.inputSavedView.centerCoordinate,
            this.inputSavedView.zoom,
            this.inputSavedView.backgroundLayerId,
            this.inputSavedView.dataLayersId,
            1000,
            true
        );
        this.trvPopoverRef.close("");
    }
    

    public removeView() {
        this.trvModalService
            .confirmDelete(this.lang.GetValue("SavedViews.DeleteView"), this.lang.GetValue("SavedViews.DeleteConfirmation") + " '" + `${this.inputSavedView.name}` + "'" + "?", this.lang.GetValue("SavedViews.DeleteViewConfirm"), this.lang.GetValue("SavedViews.KeepViewConfirm"), {
                disposeOnBackdropClick: true,
            })
            .afterCloseWithType()
            .subscribe(event => {
                if (event.closingEventType !== "close") return;

                this.localStorageService.setSavedViews(
                    this.localStorageService.savedViews.filter(view => view.id !== this.inputSavedView.id)
                );
                this.globalMessagesService.success(this.lang.GetValue("SavedViews.View") + " '" + `${this.inputSavedView.name}` + "' " + this.lang.GetValue("SavedViews.removed"));
            });
        this.trvPopoverRef.close("");
    }

    onShowComponent(ref: TrvPopoverRef<SaveViewComponent>): void {
        //console.log("SET SAVED VIEW");
        ref.componentInstance.savedViewToEdit = this.inputSavedView;
    }
}
